import React, { useState, useEffect, useCallback } from 'react';
import Layout from '../../components/layout/Layout';
import Navbar from '../../components/layout/Navbar';
import DataTable from '../../components/common/DataTable';
import Badge from '../../components/common/Badge';
import { getMembers } from '../../api/superAdminApi';
import { Users } from 'lucide-react';
import { format } from 'date-fns';
import toast from 'react-hot-toast';

const ViewMembers = () => {
  const [members, setMembers] = useState([]);
  const [loading, setLoading] = useState(true);

  const fetchMembers = useCallback(async () => {
    try {
      setLoading(true);
      const res = await getMembers();
      setMembers(res.data?.data?.members || []);
    } catch {
      toast.error('Failed to load members');
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => { fetchMembers(); }, [fetchMembers]);

  const columns = [
    { header: 'Member', accessorKey: 'name',
      cell: ({ row: { original: m } }) => (
        <div className="flex items-center gap-3">
          <div className="w-8 h-8 bg-green-100 rounded-full flex items-center justify-center flex-shrink-0">
            <span className="text-green-700 text-xs font-bold">{m.user?.name?.charAt(0) || 'U'}</span>
          </div>
          <div>
            <p className="font-semibold text-gray-900">{m.user?.name || 'Unknown'}</p>
            <p className="text-xs text-gray-400">{m.user?.email || 'No email'}</p>
          </div>
        </div>
      )},
    { header: 'Phone',   accessorKey: 'phone', cell: ({ row: { original: m } }) => m.user?.phone || '—' },
    { header: 'Group',  accessorKey: 'group_name',
      cell: ({ row: { original: m } }) => (
        <span className="badge-blue">{m.group?.group_name || 'Unknown Group'}</span>
      )},
    { header: 'Share No', accessorKey: 'share_number',
      cell: ({ row: { original: m } }) => (
        <span className="font-bold text-gray-700">{m.share_number || 1}</span>
      )},
    { header: 'Joined',   accessorKey: 'createdAt',
      cell: ({ row: { original: m } }) => (
        <span className="text-xs text-gray-500">{m.createdAt ? format(new Date(m.createdAt), 'dd MMM yyyy') : '—'}</span>
      )},
    { header: 'Status', accessorKey: 'is_active',
      cell: ({ row: { original: m } }) => <Badge status={m.is_active ? 'active' : 'inactive'} /> },
  ];

  return (
    <Layout>
      <Navbar title="All Members" subtitle={`${members.length} total members`} onRefresh={fetchMembers} loading={loading} />
      <div className="p-6">
        <div className="card">
          <div className="flex items-center gap-3 mb-6">
            <div className="bg-green-100 p-2 rounded-xl"><Users size={20} className="text-green-600" /></div>
            <div>
              <h2 className="font-bold text-gray-900">Member Registry</h2>
              <p className="text-xs text-gray-500">All bhishi members</p>
            </div>
          </div>
          <DataTable columns={columns} data={members} loading={loading} emptyMessage="No members found" />
        </div>
      </div>
    </Layout>
  );
};

export default ViewMembers;
